import React from "react";
import ShareHoldersSection from "../../components/Investor/ShareHolders.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const ShareHolder = () => {
  return (
    <>
      <MetaComponent
        title="Detailed Information for Aptech's Company Shareholders"
        desc="Aptech Limited provides detailed insights for company shareholders, including responsibilities, ownership, and shareholder rights to support transparency. Read more."
        keywords="Aptech investor relations, Aptech contact information, Investor support services "
      />
      <ShareHoldersSection />
    </>
  );
};

export default ShareHolder;
